export default "__VITE_PUBLIC_ASSET__6c5d8517__"